import Axios from '.'
import { AxiosConfigType } from '../types'
import { OptionalParamsApi, PaginationResponseSecondFormat } from '../types/api'
import { ImpersonationUser } from '../types/api/impersonation'
import { generateParamsURL } from '../utils'

const ImpersonationApi = {
getUsers: async (
    params: OptionalParamsApi,
    config: AxiosConfigType,
    regionId = '99'
): Promise<PaginationResponseSecondFormat<ImpersonationUser>> => {
    const url = `admin/impersonation/users/${regionId}?${generateParamsURL(params)}`

    const response = await Axios.get(url, config)
    return response.data
},
}

export default ImpersonationApi
